export const INIT_EMOTE_STATE: EmotesCollection = {
    emotes: [],
    emojiCount : 0
};

export interface EmotesCollection {
    emotes: any[];
    emojiCount: number;
}

export interface DeductEmotesCountInFireBase {
    clientId: string;
    gameStateId: string;
    tournamentType: string;
}
